module.exports = __webpack_public_path__ + "static/media/people.f3ca33dd.svg";